<template>
    <div class="clientDetail">
      <!--navBar-->
      <navBar></navBar>
      <!--中间内容部分-->
      <div class="main">
        <div class="mainContainer">
          <div class="nav_detail">
            <span class="nav_back" @click="goBack">案例中心</span> > <span>杭州市妇产科医院</span>
          </div>
          <div class="flex_between">
            <div class="item_left">
              <div class="icon"><i></i></div>
              <p class="title">杭州市妇产科医院</p>
              <div class="intro">
                <div>客户简介</div>
                <p>杭州市妇产科医院，又名杭州市妇幼保健院，是杭州市卫计委直属的集医疗、保健、教学、科研于一体的公立医院，按三级甲等专科医院的标准设计建造，现为杭州市高危孕产妇急救中心、杭州市产前诊断（筛查）中心、杭州市儿童听力诊断中心、杭州市围绝经期保健中心、杭州市妇女盆底功能障碍性疾病诊治中心、杭州市妇科内分泌疾病诊治中心。</p>
              </div>
              <div class="products">
                <div>使用产品</div>
                <p @click="goProduct('/product2')">渗透测试</p>
                <p @click="goProduct('/product3')">专家服务</p>
              </div>
            </div>
            <div class="item_right">
              <div class="title">
                <i></i>业务背景
              </div>
              <p>随着互联网、大数据、云计算技术的快速发展，我国医疗机构的信息化程度越来越高，逐步向数字化医疗、智慧医疗发展。新型技术的使用必然会带来新的安全风险。此外，医疗数据的高价值特性，吸引大量攻击者尝试通过窃取、买卖医疗敏感数据牟取暴利。据悉，医疗敏感数据在暗网中的交易价格可达信用卡数据的10倍。</p>
              <div class="item_img"><img src="../../assets/img/clientDetail/client6_big.jpg" alt=""></div>
              <div class="title">
                <i></i>解决方案
              </div>
              <p>清除恶意软件，阻止黑客进一步攻击，对安全漏洞进行加固，协助客户尽快恢复业务的正常服务。专家分析安全事件类型，分析入侵路径；清理木马病毒、WebShell 后门、黑客工具等威胁内容。以最快的速度对客户业务进行接入，避免继续造成损失，制定正确应对措施，帮助客户快速恢复业务。</p>
              <div class="title">
                <i></i>方案价值
              </div>
              <p>针对系统存在的高危漏洞和安全隐患等提供安全加固方案，整体上提高系统的安全防御能力，同时加强在医疗信息安全领域的投入、建立系统化的安全保障体系，从事件的被动应急响应提升为安全风险的主动感知，从而提升安全管理能力。   </p>
            </div>
          </div>
        </div>
      </div>
      <!--footerBar-->
      <div class="gw_homefooterBox">
        <footerBar></footerBar>
      </div>
    </div>
</template>

<script>
    import navBar from '../../components/Navbar';
    import footerBar from '../../components/footerbar'
    export default {
      components:{
        navBar,footerBar
      },
      methods:{
        goBack(){
          this.$router.push('/client');
        },
        goProduct(url){
          this.$router.push(url);
          window.scrollTo({top:0});
        }
      }
    }
</script>

<style scoped lang="scss">
  .clientDetail{
    .item_left{
      .icon{
        i{
          width:188px;
          height:52px;
          background:url("../../assets/img/clientDetail/client6_icon.png") no-repeat center;
          background-size:100% 100%;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/client/client6.vue